import { createSelector } from "reselect";
import { getAccountsData } from "selectors/accounts";
import { getActiveOrganization, getAllUsersData } from "./organizations";
import { getContactsData } from "./contacts";
import { getInstitutionAccountsData } from "./institutions";
import Countries from "const/Countries";
import Transactions from "utils/Transactions";

export const checkTransactionsFetching = ({ transactions: { fetchingData } }) => fetchingData;

export const getLockedTransactions = ({ transactions: { locked } }) => locked;

export const getTransactionsTags = ({ transactions: { tags } }) => tags;

export const getTransactionsReasons = ({ transactions: { reasons } }) => reasons;

export const getTransactionsStats = ({ transactions: { stats } }) => stats;

export const getTransactionsData = createSelector(
  [
    ({ transactions: { data } }) => data,
    getAccountsData,
    getInstitutionAccountsData,
    getAllUsersData,
    getActiveOrganization,
    getContactsData
  ],
  (data, accounts, institutionAccounts, users, organization, contactsData) => {
    const { countryCode } = organization || {};

    const accountsData = countryCode === Countries.CZ ? institutionAccounts : accounts;

    return data.map(({ accountId, askClientInfo, ...restData }) => {
      const contact = Transactions.searchContact(contactsData, restData.vendorId, restData.vendorName, restData.usesItems);

      return {
        ...restData,
        account: accountsData.find(({ id }) => id === accountId) || {},
        askClientInfo: askClientInfo && askClientInfo.askedEmail
          ? {
            ...askClientInfo,
            askedBy: users.find(({ id }) => id === askClientInfo.askedBy) || undefined,
            askedUser: users.find(({ email }) => email.toLowerCase() === askClientInfo.askedEmail.toLowerCase())
            || { email: askClientInfo.askedEmail }
            || null
          }
          : null,
        ...(contact ? {
          vendorId: contact.id,
          address: {
            ...restData.address,
            needDocument: contact.needDocument,
            name: contact.name
          }
        } : {})
      };
    });
  }
);
